import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";

const getContentStatus = async (data) => {
    try {
        return await needAuth.post(`/contentStatus`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data};
        }
    }
}

const changeNextContentStatus = async (data) => {
    try {
        return await needAuth.post(`/contentStatus/next`, data)
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data};
        }
    }
}

const changePreviousContentStatus = async (data) => {
    try {
        return await needAuth.post(`/contentStatus/previous`, data)
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data};
        }
    }
}

const createReworkRequest = async (data) => {
    try {
        return await needAuth.post(`/reworkRequest/create`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const getReworkRequestList = async (data) => {
    try {
        return await needAuth.get(`/reworkRequest/list`, {params: data});
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data};
        }
    }
};

/** List<ReworkResponse> — 신규 TaskManager 활동 피드용 */
const getReworkList = async (data) => {
    try {
        return await needAuth.get(`/reworkRequest/new-list`, {params: data});
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data};
        }
    }
};

export {
    getContentStatus,
    changeNextContentStatus,
    changePreviousContentStatus,
    createReworkRequest,
    getReworkRequestList,
    getReworkList,
};